// import React, { useState } from "react";
// import { Helmet } from "react-helmet"; // Helmet import

import RandingStyle1 from "../../randing/RandingStyle1";

function Randing001({ urlCode, urlCodeSettingId }) {
  return (
    <RandingStyle1
      urlCode={urlCode}
      urlCodeSettingId={urlCodeSettingId}
      totalStep="2"
      img1Path={`${process.env.REACT_APP_CDN_BASE}/images/001/01_241029_01.jpg`}
      changedIMG={`${process.env.REACT_APP_CDN_BASE}/images/001/02_241029_02.jpg`} // 스텝 변경되는 이미지
      img2Path={`${process.env.REACT_APP_CDN_BASE}/images/001/01_241029_02.jpg`}
      numberColor="#3f8c58"
      qOptionColor="green"
      keepBTN={`${process.env.REACT_APP_CDN_BASE}/images/001/01_241029_01_btn_send.png`}
      postBTN={`${process.env.REACT_APP_CDN_BASE}/images/001/02_241029_01_btn_send.png`}
      companyName="본원"
      // footerPath={`${process.env.REACT_APP_CDN_BASE}/images/footer/woori.jpg`}
      articleOption={true}
    />
  );
}

export default Randing001;
